<script>
    import { onMount, createEventDispatcher } from 'svelte'
    import { ChevronBackOutline, ChevronFordwareOutline } from '../Icons'
    import { fade } from 'svelte/transition'
    import slide from '../../custom/animations/slide'
    import { SimplySelect, PopUp, VoidBox } from '.'
    import { Datetime, getCSSVar, range, clickOutside } from '$lib/utils'
    const dispatch = createEventDispatcher()
    let today = new Datetime()
    export let currentDate = new Datetime(...today.values({ day: 1 }))
    export let year = 0
    export let month = 0
    export let day = 0
    export let value = null
    export let display = false
    export let startSunday = true
    let months = [
        'ENE',
        'FEB',
        'MAR',
        'ABR',
        'MAY',
        'JUN',
        'JUL',
        'AGO',
        'SEP',
        'OCT',
        'NOV',
        'DIC',
    ]
    let weak = !startSunday
        ? ['L', 'M', 'M', 'J', 'V', 'S', 'D']
        : ['D', 'L', 'M', 'M', 'J', 'V', 'S']
    let selectedDate
    export let date = null
    function onClose() {
        dispatch('close', {})
    }
    function onSelect() {
        dispatch('select', {})
    }
    function onclickOut() {
        dispatch('clickout', {})
    }
    function onChange() {
        dispatch('change', {})
    }
    onMount((_) => {
        if (year === 0) year = currentDate.year
        if (month === 0) month = currentDate.month
        if (day === 0) day = currentDate.day
    })
    $: if (date) {
        value = `${date.year}-${String(date.month).padStart(2, '0')}-${String(date.day).padStart(2, '0')}`
        onChange()
    }
    $: if (selectedDate) {
        currentDate = currentDate.delta({ months: selectedDate, days: 1 })
    }
    $: afterMonth = currentDate.delta({ months: 1 })
    $: beforeMonth = currentDate.delta({ months: -1 })

    $: options = [...range(-5, 1, 1), ...range(1, 6)].map((x) => {
        return {
            label:
                months.at(currentDate.delta({ months: x }).month - 1) +
                ' ' +
                currentDate.delta({ months: x }).year,
            value: x,
        }
    })
</script>

<svelte:component this={display ? PopUp : VoidBox} visible={true}>
    <div
        transition:slide
        use:clickOutside
        on:clickout={onclickOut}
        class="frame"
    >
        {#key currentDate}
            <div transition:fade class="header">
                <i
                    on:click={(_) => {
                        currentDate = beforeMonth
                    }}
                    ><ChevronBackOutline
                        color={getCSSVar('--color-grey-400')}
                    /></i
                >
                <SimplySelect
                    bind:value={selectedDate}
                    currentIndex={5}
                    style="width: 105px"
                    {options}
                    placeholder=""
                />
                <i
                    on:click={(_) => {
                        currentDate = afterMonth
                    }}
                    ><ChevronFordwareOutline
                        color={getCSSVar('--color-grey-400')}
                    /></i
                >
            </div>
        {/key}
        <div
            class="calendar"
            style="position: relative; width: 300px; height: 300px"
        >
            {#each weak as day}
                <span class="head">{day}</span>
            {/each}
            {#each range(beforeMonth.getDaysOfMonth() + 1 - currentDate.getFirstDayOfMonth(), beforeMonth.getDaysOfMonth() + 1) as ad}
                <span style="color:grey"><i class="rest">{ad}</i></span>
            {/each}
            {#each range(1, currentDate.getDaysOfMonth() + 1) as d}
                <span>
                    <i
                        class={`${today.equals(new Datetime(...currentDate.values({ day: d }))) ? 'today' : ''} ${date && date.equals(new Datetime(...currentDate.values({ day: d }))) ? 'active' : ''}`}
                        on:click={(_) =>
                            (date = new Datetime(
                                ...currentDate.values({ day: d })
                            ))}
                    >
                        {d}
                    </i>
                </span>
            {/each}
            {#each range(1, 14 - currentDate.getLastDayOfMonth() - (currentDate.getLastDayOfMonth() >= 2 || (currentDate.getFirstDayOfMonth() === 0 && currentDate.getDaysOfMonth() <= 30) ? 0 : 7)) as ad}
                <span><i class="rest">{ad}</i></span>
            {/each}
        </div>
        <div class="footer">
            <i on:click={onClose}>Cancelar</i>
            <i class="divider"></i>
            <i on:click={onSelect}>Confirmar</i>
        </div>
    </div>
</svelte:component>

<!-- on:click={_ => {
  currentDate = beforeMonth;
  date = new Datetime(...currentDate.values({day: ad}));
  } } -->

<style>
    .frame {
        width: 350px;
        display: grid;
        grid-template-columns: 1fr;
        grid-template-rows: 56px 1fr 56px;
        background: #ffffff;
        box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.1);
        max-height: 425px;
    }
    .calendar {
        display: grid;
        grid-row: 2;
        grid-column: 1;
        width: 100%;
        padding: 0 calc(35% / 7);
        grid-template-columns: repeat(7, 1fr);
        grid-template-rows: repeat(7, 1fr);
        /* background: rgba(0,0,0,0.1); */
        /* grid-row-gap: 16px;*/
        grid-column-gap: calc(35% / 7);
        /* height: auto; */
    }
    .calendar span {
        display: flex;
        /* width: calc(100%/5); */
        justify-content: center;
        align-items: center;
        font-style: normal;
        font-weight: 400;
        user-select: none;
        font-size: 14px;
        line-height: 17px;
        text-align: center;
        letter-spacing: 0.4px;
        /* color: var(--color-black);
    cursor: pointer;
    border-radius: 50%; */
    }
    i {
        cursor: pointer;
    }
    .calendar span i {
        display: flex;
        width: 32px;
        height: 32px;
        font-style: normal;
        justify-content: center;
        align-items: center;
        color: var(--color-black);
        cursor: pointer;
        border-radius: 50%;
    }
    .footer {
        grid-column: 1;
        grid-row: 3;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        align-items: center;
        user-select: none;
    }
    .footer i {
        color: var(--color-black);
        font-style: normal;
        font-weight: 400;
        font-size: 17px;
        width: 100%;
        text-align: center;
        line-height: 22px;
        letter-spacing: 0.2px;
    }
    .header {
        grid-column: 1;
        grid-row: 1;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding: 0 15px;
        border-bottom: 1px var(--color-grey-300) solid;
    }
    span i.today {
        border: 1px #c0c0c0 solid;
    }

    span i.active {
        background: var(--color-brand-primary-01);
        color: white;
    }
    span i.rest {
        color: var(--color-grey-300);
        cursor: no-drop;
    }
    span.head {
        color: var(--color-grey-800);
    }
    .divider {
        display: block;
        height: 40px;
        width: 1.5px !important;
        background-color: var(--color-grey-300);
        cursor: progress;
    }
</style>
